var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "24px",
    height: "24px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.395,7.081c-0.488,-0.207 -1.053,-0.002 -1.29,0.472c-0.224,0.448 -0.523,0.723 -0.914,0.838c-0.612,0.183 -1.343,-0.052 -1.685,-0.253c-0.451,-0.265 -0.974,-0.667 -1.527,-1.092c-1.765,-1.358 -3.961,-3.046 -6.979,-3.046c-2.414,0 -3.654,1.239 -5.707,3.293c-0.391,0.391 -0.394,1.027 -0.003,1.417c0.38,0.382 0.99,0.394 1.382,0.03c0.01,-0.009 0.02,-0.019 0.03,-0.028c0.552,-0.426 4.03,-0.012 5.55,1.196c2.259,1.795 3.89,3.092 5.748,3.092c2.659,0 4.879,-1.741 5.94,-4.658c0.181,-0.498 -0.058,-1.051 -0.545,-1.261zM18.395,14.081c-0.488,-0.207 -1.053,-0.002 -1.29,0.472c-0.224,0.448 -0.523,0.723 -0.914,0.838c-0.612,0.18 -1.343,-0.052 -1.685,-0.253c-0.451,-0.265 -0.974,-0.667 -1.527,-1.092c-1.765,-1.358 -3.961,-3.046 -6.979,-3.046c-2.414,0 -3.654,1.239 -5.707,3.293c-0.391,0.391 -0.394,1.027 -0.003,1.417c0.38,0.382 0.991,0.395 1.383,0.03c0.01,-0.009 0.02,-0.019 0.03,-0.028c0.551,-0.426 4.031,-0.012 5.55,1.196c2.258,1.795 3.889,3.092 5.747,3.092c2.659,0 4.879,-1.741 5.94,-4.658c0.181,-0.498 -0.058,-1.051 -0.545,-1.261z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.1574312f22706bb3730683238dee5442.svg";
export { ForwardRef as ReactComponent };